export enum PlayerEventTypeEnum {
    LOADEDMETADATA = 'loadedmetadata', // 加载视频信息完成
    TIMEUPDATE = 'timeupdate', // 播放进度更新
    PLAY = 'play', // 视频播放
    PAUSE = 'pause', // 视频暂停
    ENDED = 'ended' // 视频播放结束
}

export enum TimCustomMessageTypeEnum {
    PUSH_START = 0, // 推流开始
    JOIN_USER = 1, // 用户加入
    PUSH_PAUSE = 2, // 推流中断
    PUSH_END_USER = 3, // 用户主动结束直播
    PUSH_END_MANNER = 4, // 后台终止直播
    COMMENT_USER = 5, // 用户评论
    PUSH_PAUSE_USER = 6, // 用户主动暂停
    PUSH_REPLAY_USER = 7 // 用户主动恢复直播
}

export enum LiveStatusEnum {
    LIVE_STATUS_ONGOING = '0', // 直播中
    LIVE_STATUS_BOOKING = '1', // 预约
    LIVE_STATUS_PAUSE = '2', // 暂停
    LIVE_STATUS_END_USER = '3', // 用户结束直播
    LIVE_STATUS_END_MANNER = '4', // 后台终止
    LIVE_STATUS_END_PLAYBACK = '99' // 结束并有回放
}

export enum TimGroupTipTypeEnum {
    JOIN_MEMBER = 1, // 用户加入
    UPDATE_GROUP_PROFILE = 6 // 更新群信息
}
